import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { observer } from 'mobx-react';

import { useStore } from 'utils/hooks/store';

import TruncatedText from 'components/TruncatedText';

import { MIN_STAGE_PILL_WIDTH, Name, StyledDragIndicatorIcon, StyledSortableStage } from './styles';

const SortableStage = ({ stageKey }: { stageKey: string }): React.ReactElement => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: stageKey });

  const { pipelineDetails } = useStore();

  const stage = pipelineDetails.data?.stages.find(({ key }) => key === stageKey);
  const isSelected = pipelineDetails.selectedStage === stageKey;

  if (!stage || stage.closed) {
    return <></>;
  }

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    flex: 1,
    minWidth: `${MIN_STAGE_PILL_WIDTH}px`,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <TruncatedText<HTMLParagraphElement> text={stage.name}>
        {(nameRef) => (
          <StyledSortableStage
            tabIndex={0}
            role="button"
            $isSelected={isSelected}
            onClick={() => pipelineDetails.setSelectedStage(stageKey)}
          >
            <StyledDragIndicatorIcon {...listeners} $isSelected={isSelected} />
            <Name ref={nameRef} $isSelected={isSelected}>
              {stage.name}
            </Name>
          </StyledSortableStage>
        )}
      </TruncatedText>
    </div>
  );
};

export default observer(SortableStage);
